import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MappingViewComponent } from "../../modal-templates/mapping-view/mapping-view.component";
import { SharedComponents } from "../../shared.module";

/**
 * The `CodeQualityComponent` handles displaying the code quality aspects of files within a project.
 * It includes functionality to display a list of files and open a mapping dialog for further details.
 * The component uses Angular Material Dialog for viewing the file mappings in a dialog window.
 */
@Component({
  selector: "app-code-quality",
  standalone: true,
  imports: [
    MatGridListModule,
    CommonModule,
    MatIconModule,
    ...SharedComponents,
  ],
  templateUrl: "./code-quality.component.html",
  styleUrl: "./code-quality.component.scss",
})
export class CodeQualityComponent {
  /**
   * Constructs the `CodeQualityComponent` with injected `STEP_DATA` for step-wise navigation
   * and `MatDialog` for handling modal dialogs.
   * @param data - The injected step data to be used for navigation in a multi-step process.
   * @param dialog - The Angular Material Dialog service used to open dialogs.
   */
  constructor(
    @Inject("STEP_DATA") public data: any,
    public dialog: MatDialog
  ) {}

  files = [
    { name: "APIConstantsSetup.java" },
    { name: "SpecificationSetup.java" },
    { name: "CreateBookingTests.java" },
    { name: "BookingData.java" },
    { name: "BookingDates.java" },
    { name: "SerializeBookingData.java" },
    { name: "CartPage.java" },
    { name: "HomePage.java" },
    { name: "ProductDetailsPage.java" },
    { name: "SearchResultPage.java" },
    { name: "CartPage.java" },
    { name: "HomePage.java" },
    { name: "ProductDetailsPage.java" },
    { name: "SearchResultPage.java" },
  ];

  /**
   * Opens a dialog to view the detailed mapping of the code quality analysis for a selected file.
   * Uses the `MatDialog` service to open the `MappingViewComponent` dialog.
   */
  openMappingDialog(): void {
    this.dialog.open(MappingViewComponent, {
      // width: '100%',
      // height: '80vh',
      // maxWidth: '90%',
    });
  }
}
